
import WidgetDefaultNuxt from '../default/nuxt.vue';
import VLazyImage from './v-lazy-image.js';
import { formatImageSrc } from '@xd-rocket/utils/base';

export default {
  name: 'WidgetImageNuxt',
  components: {
    VLazyImage,
  },
  extends: WidgetDefaultNuxt,
  data: function () {
    const { values, getLocaleValue } = this;

    let src = getLocaleValue(values.src) ?? '';
    let lazy = values.isLazyLoad;
    return {
      widgetClassName: 'widget-image',
      src,
      lazy,
      alt: getLocaleValue(values.alt),
      staticEvent: !!values.static?.event && !lazy,
      localePath: [
        { key: 'alt', value: values.alt },
        { key: 'src', value: values.src },
      ],
    };
  },
  computed: {
    srcInfo() {
      let obj = formatImageSrc(this.src, this.ossImgRatio);
      let result = { src: obj.src };
      if (obj.isValid) {
        if (typeof Window !== 'undefined') {
          //仅在客户端且普通屏时设置 srcset, 避免 html2canvas 在 retina 屏幕上有问题
          if (window.devicePixelRatio === 1) {
            result.srcset = obj.srcset;
          } else {
            result.srcset = '';
          }
        } else {
          result.srcset = obj.srcset;
        }
      }
      return result;
    },
  },
  methods: {
    initEvent() {
      if (!this.values.static?.event) {
        // 事件编辑器和自定义代码有关于组件的事件
        this.rocketOn('rocket:image:update-src', true, (v) => {
          this.src = v;
          if (this.localePath.length) {
            this.localePath = [{ key: 'alt', value: this.values.alt }];
            this.updateLocalePathMap();
          }
        });
        this.rocketOn('rocket:image:src-to-base64', true, this.getBase64);
      }
      if (this.lazy) {
        // 轮播图中会有懒加载相关的触发事件
        this.rocketOn('rocket:image:lazy-load', true, this.handleLoadImage);
      }
    },
    handleLoadReady(el) {
      this.rocketEmit('rocket:image:lazy-load-success', true);
    },
    handleLoadImage() {
      if (!this.srcInfo.src) return;
      this.$refs.img.handleIntersect();
      this.rocketOff('rocket:image:lazy-load', true, this.handleLoadImage);
    },
    getBase64() {
      const url = this.srcInfo.src;
      if (!url) {
        this.rocketEmit('rocket:image:src-to-base64-success', true, '');
      }
      var img = new Image(),
        dataURL = '';
      img.crossOrigin = 'Anonymous';
      img.setAttribute('crossOrigin', 'Anonymous');
      if (url.indexOf('?') > -1) {
        img.src = url + '&v=' + Math.random();
      } else {
        img.src = url + '?v=' + Math.random();
      }
      img.onload = () => {
        var canvas = document.createElement('canvas'),
          width = img.width,
          height = img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        dataURL = canvas.toDataURL('image/png');
        this.rocketEmit('rocket:image:src-to-base64-success', true, dataURL);
      };
      img.onerror = (err) => {
        console.log('Error occurred while loading image:', err);
        this.rocketEmit('rocket:image:src-to-base64-success', true, '');
      };
    },
  },
};
